"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIKeysUpdateKeyName = exports.APIKeysUpdateKeyNameOperationId = void 0;
const ClientController_1 = require("../../../../../ClientController");
exports.APIKeysUpdateKeyNameOperationId = 'APIKeysUpdateKeyName';
/**
 * Updates the name of an existing API key
 *
 * @path /api-keys/:keyId/update-name
 * @generated
 */
exports.APIKeysUpdateKeyName = (0, ClientController_1.ClientControllerFactory)({
    path: '/api-keys/:keyId/update-name',
    method: 'PATCH',
    definedStatusCodes: [204, 400, 500],
});
